<template>
    <section>
        <ui-modal
            :title="properTitle"
            :load-success="loader.modalSuccess"
            :load="loader.modalLoading"
            name="select-subscrib"
            size="sm"
            color-circle="icon-primary"
            custom-loader
            @close="close"
        >
            <template #custom-loader>
                <ui-loader-message
                    :message="loader.message"
                    :description="loader.description"
                    :loading="loader.modalLoading"
                    :success="loader.modalSuccess"
                    :failed="loader.modalFailed"
                    :close-action="realoadAndClose"
                />
            </template>

            <div v-show="loader.body" class="loading-area">
                <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
            </div>

            <div v-if="!loader.body" class="content scroll-color">
                <div class="subtitle">
                    {{ properSubtitle }} <strong v-if="productMode">{{ productName }}</strong>
                </div>

                <div class="search-user">
                    <ui-input
                        v-model="form.name"
                        :loading="loader.name"
                        placeholder="Buscar usuário"
                        groupicon="fal fa-search"
                        type="text"
                        size="lg"
                        complete-event="search-user--verify-username"
                        loading-icon-group
                    >
                        <section v-if="showUsers" class="search-user-card">
                            <div class="content-card scroll-color">
                                <div
                                    v-for="(user, index) in users"
                                    :key="index"
                                    class="container-search-user"
                                >
                                    <div class="user">
                                        <div class="user-data">
                                            <em class="fal fa-user-circle" />
                                            <span>{{ user.first_name }}</span>
                                        </div>

                                        <div class="user-office">
                                            Cargo:
                                            <span>{{ getGroupLabel(user.group) }}</span>
                                        </div>

                                        <div class="user-email">
                                            Email:
                                            <span>{{ user.email }}</span>
                                        </div>
                                    </div>

                                    <div class="check-box">
                                        <ui-checkbox
                                            :checked.sync="user.selected"
                                            design="xs success circle"
                                            @input="selectUserHandler(user)"
                                        />
                                    </div>
                                </div>
                            </div>

                            <section class="footer-user-card">
                                <span class="cancelFound" @click="closeCardHandler">Cancelar</span>

                                <ui-button design="primary sm mw-100" @click="setSelectedSigners">
                                    Adicionar
                                </ui-button>
                            </section>
                        </section>

                        <div v-if="emptyUsers" class="user-empty">
                            Nenhum usuário encontrado!
                        </div>
                    </ui-input>
                </div>

                <div v-if="productMode" class="clone">
                    <strong>Clonar configurações do empreendimento:</strong>
                    <ui-select-v2
                        v-model="flowData.selectedAllSigners"
                        :data="flowData.allSigners"
                        :loading="loader.allSigners"
                        class="select-2-mini"
                        placeholder="Selecione"
                        design="br-default"
                        item-label="name"
                        return-value="products_id"
                        @click="cloneHandler"
                        @cancel="cloneHandler('cancel')"
                        @search="cloneHandler('search')"
                    />
                </div>

                <div
                    v-if="properList.length && !validSelectedAllSigners" class="dragable"
                    :class="scrollActiveClass"
                    :style="scrollActive">
                    <draggable
                        :list="properList"
                        :disabled="enabled"
                        class="list-group"
                        ghost-class="ghost"
                        @start="dragging = true"
                        @end="dragging = false"
                    >
                        <div
                            v-for="(element, index) in properList"
                            :key="index"
                            class="list-group-item"
                        >
                            <div class="dragables">
                                <div
                                    class="drag-image"
                                    @mouseover="enabled = false"
                                    @mouseleave="enabled = true"
                                >
                                    <img :src="require('@/assets/imgs/drag-and-drop.svg')" />
                                </div>

                                <div class="checkbox">
                                    <ui-checkbox
                                        v-model="element.checked"
                                        :checked="element.checked"
                                        :design="checkboxDesign(element)"
                                    />
                                </div>

                                <!-- usuários selecionados via busca -->
                                <div v-if="element.selected" class="infos-user">
                                    <div class="name">{{ element.name }}</div>
                                    <div class="email" :title="element.email">{{ element.email }}</div>
                                    <div class="group">{{ element.group_name }}</div>

                                    <div v-if="element.signatureType === 3" class="inperson-signature-extra-infos">
                                        <div class="cpf">{{ formatCPF(element.cpf) }}</div>
                                        <div class="birth-date">{{ formatBirthDate(element.birthday) }}</div>
                                    </div>
                                </div>

                                <!-- usuários pré-selecionados -->
                                <div v-else-if="element.group" class="infos-user">
                                    <div class="name">{{ element.name }}</div>
                                    <div class="groups">{{ element.group }}</div>

                                    <div v-if="element.signatureType === 3" class="inperson-signature-extra-infos">
                                        <div class="cpf">{{ formatCPF(element.cpf) }}</div>
                                        <div class="birth-date">{{ formatBirthDate(element.birthday) }}</div>
                                    </div>
                                </div>

                                <!-- novos usuários -->
                                <div v-else-if="element.new" class="infos-user">
                                    <input
                                        v-model="element.name"
                                        class="name-input"
                                        placeholder="Clique aqui para digitar o nome"
                                    />

                                    <input
                                        v-model="element.email"
                                        class="email-input"
                                        placeholder="Digite o e-mail"
                                    />

                                    <ui-input
                                        v-model="element.whatsapp_number"
                                        size="sm"
                                        :mask="['(##) ####-####', '(##) #####-####']"
                                        required
                                        type="text"
                                        placeholder="Digite o celular (Whatsapp)"
                                    />

                                    <div v-if="element.signatureType === 3" class="inperson-signature-extra-infos">
                                        <ui-input
                                            v-model="element.cpf"
                                            size="sm"
                                            :mask="['###.###.###-##']"
                                            placeholder="Digite o CPF"
                                        />

                                        <ui-input
                                            v-model="element.birthday"
                                            size="sm"
                                            :mask="['##/##/####']"
                                            placeholder="Data de Nascimento" />
                                    </div>
                                </div>
                            </div>
                            <div
                                class="options"
                                :class="{
                                    'cant-delete': cantDelete(element),
                                    'has-menu': !hasMenu,
                                }"
                            >
                                <div class="select">
                                    <ui-select-v2
                                        v-model="element.signatureType"
                                        :data="flowData.sigsType"
                                        :search="false"
                                        return-value="id"
                                        item-label="name"
                                        placeholder="Selecione o tipo de assinatura"
                                        @input="signatureTypeHandler"
                                        @remove-select="selectHandler('remove')"
                                        @cancel="selectHandler"
                                    />
                                </div>
                                <ui-menu-card v-if="hasMenu && !cantDelete(element)" fixed>
                                    <button @click="deleteSignerFromList(element)">Excluir</button>
                                </ui-menu-card>
                            </div>
                        </div>
                    </draggable>
                </div>
                <!-- <div v-else>
					<small>Não há dados para exibir.</small>
				</div> -->
                <div v-if="!validSelectedAllSigners" class="plus-users" :style="plusBoxShadow">
                    <button class="plus-button" @click="add">
                        <em class="fal fa-plus" aria-hidden="true" />
                    </button>
                </div>
                <div v-else class="clone-warning">
                    Ao clicar '<strong>Salvar</strong>', as configurações do empreendimento
                    selecionado <strong>serão clonadas</strong> para o empreendimento
                    <strong>{{ productName }}</strong
                    >. Todas as configurações realizadas anteriormente serão desconsideradas.
                </div>
            </div>

            <template #footer>
                <div class="save">
                    <ui-button :disabled="cantSave" design="success wsm" @click="handleSaveButton">
                        Salvar
                    </ui-button>
                </div>
            </template>
        </ui-modal>
    </section>
</template>

<script>
	import { uiCheckbox, uiSelectV2, uiInput } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiMenuCard, uiLoadIndicator } from '@/components/ui'
	import { uiLoaderMessage } from '@/components/ui/loader'

	import { deal, digitalSignature, product, user } from '@/services/axios'
	import { storage } from '@/services/storage'

	import { documentBr } from '@/filters'

	import draggable from 'vuedraggable'

	const moment = require('moment')
    require('moment/locale/pt-br')

	const defaultFlowData = () => ({
		list: [],

		productList: [
			{
				name: 'Clientes',
				group: 'Cliente do Negócio',
				checked: true,
			},
			{
				name: 'Gerente',
				group: 'Gerente de Vendas',
				checked: false,
			},
			{
				name: 'Corretor',
				group: 'Corretor de Imóveis',
				checked: false,
			},
		],
		sigsType: [
			{
				id: 1,
				name: 'Assinatura Eletrônica',
			},
			{
				id: 2,
				name: 'Assinatura Digital',
			},
			{
				id: 3,
				name: 'Assinatura Presencial',
			},
		],

		allSigners: [],
		selectedAllSigners: null,
		currentProductSigners: null,
	})

	const defaultParamsData = () => ({
		files: null,
		flowName: null,
		flowType: null,
		dealId: null,
		dealData: null,
		productId: null,
	})

	const defaultLoader = () => ({
		body: false,
		name: false,
		modalLoading: false,
		modalSuccess: false,
		modalFailed: false,
		message: '',
		description: '',
		allSigners: false,
	})

	const defaultForm = () => ({
		name: '',
	})

	export default {
		name: 'select-subscribs',

		components: {
			draggable,
			uiModal,
			uiCheckbox,
			uiSelectV2,
			uiMenuCard,
			uiButton,
			uiLoadIndicator,
			uiInput,
			uiLoaderMessage
		},

		filters: { documentBr },

		props: {
			productMode: {
				type: Boolean,
				default: false,
			},
			/**
			 * Prop que define se o menu será mostrado para as opções
			 * de assinantes
			 */
			hasMenu: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data() {
			return {
				enabled: false,
				dragging: false,
				showUsers: false,
				emptyUsers: false,

				flowData: { ...defaultFlowData() },
				paramsData: { ...defaultParamsData() },
				loader: { ...defaultLoader() },
				form: { ...defaultForm() },
				interval: null,
				users: [],
				temporary: {
					ids: [],
					signers: []
				},
				selectedIds: [],
				configurations: {
					manager: {
						label: storage.get('label_manager')
					},
					broker: {
						label: storage.get('label_broker')
					}
				}
			}
		},

		computed: {
			draggingInfo() {
				return this.dragging ? 'under drag' : ''
			},
			/**
			 * Computed property que define se o salvamento será desabilitado ou não
			 */
			cantSave() {
				let result = false
				let haveSignatureTypeInEverything = false
				const selectedSigners = [...this.properList].filter((item) => item.checked)

				// Is able to continue if has signature type selected on all signers
				if (selectedSigners.length) {
					haveSignatureTypeInEverything = selectedSigners.map(item => {
						let signatureType = item.signatureType || item.signature_type
						/**
						 * Caso a assinatura seja do tipo presencial e esteja na etapa 2 ou o usuário seja
						 * Facilita (ou Não Facilita), verifica se a data de nascimento e o CPF foram informados
						 */
						if ((!this.productMode ||
							!['Cliente do Negócio', 'Gerente de Vendas', 'Corretor de Imóveis'].includes(item.group)) &&
								signatureType === 3) {
							signatureType = (item.birthday && item.cpf)
							// Verifica se o assinante não possui CPF ou Data de Nascimento
							if (!signatureType) {
								this.$toastr.e(`O assinante ${item.name} não possui CPF ou Data de Nascimento cadastrados.`)
							}
						}

						return (signatureType && !Array.isArray(signatureType))
					}).every(signature => signature)
				}

				// If is loading, can't save
				if (this.loader.body || this.loader.modalLoading) {
					result = true

				} else {
					// Check if a product configuration was selected
					result = this.validSelectedAllSigners ? false : !haveSignatureTypeInEverything
				}

				return result
			},

			properTitle() {
				return this.productMode
					? 'Configurações - Assinaturas Requeridas'
					: 'Fluxo de Assinatura - Selecionar Assinantes'
			},

			properSubtitle() {
				return this.productMode
					? `Selecione as assinaturas que serão requeridas em todos os contratos de compra e venda das unidades do empreendimento`
					: 'Selecione ou pesquise os usuários que devem assinar o contrato, ordem e os tipos de assinatura:'
			},

			signersOnProduct() {
				return this.flowData &&
					this.flowData.currentProductSigners &&
					this.flowData.currentProductSigners.signers.length
					? true
					: false
			},
			/**
			 * Computed property que controla o array de assinantes
			 */
			properList: {
				get() {
					return this.productMode && !this.signersOnProduct
						? this.flowData.productList
						: this.flowData.list
				},
				set(value) {
					if (this.productMode && !this.signersOnProduct) {
						this.flowData.productList = value

					} else {
						this.flowData.list = value
					}
				}
			},

			scrollActiveClass() {
				return this.properList.length > 2 ? 'scroll-color' : null
			},

			scrollActive() {
				let active = this.properList
				let scroll = null
				if (active.length > 2) {
					scroll = 'height: 180px; overflow-y: auto; overflow-x: hidden'
				}
				return scroll
			},

			plusBoxShadow() {
				return this.properList.length > 2 ? 'box-shadow: 0px -4px 6px rgb(227 227 240 / 20%)' : null
			},

			validSelectedAllSigners() {
				return this.flowData.selectedAllSigners &&
					!Array.isArray(this.flowData.selectedAllSigners)
					? true
					: false
			},

			productName() {
				const productName =
					this.flowData &&
					this.flowData.currentProductSigners &&
					this.flowData.currentProductSigners.product &&
					this.flowData.currentProductSigners.product.name
						? this.flowData.currentProductSigners.product.name
						: ''

				return productName
			},

			productId() {
				const productId =
					this.flowData &&
					this.flowData.currentProductSigners &&
					this.flowData.currentProductSigners.product &&
					this.flowData.currentProductSigners.product.id
						? this.flowData.currentProductSigners.product.id
						: ''

				return productId
			},

			getConjugeProponentes() {
				const groups = this.paramsData.dealData ? this.paramsData.dealData.groups : []
				let groupsFilter = []

				groups.forEach((group) => {
					const fields = group.fields

					fields.forEach((field) => {
						const options = field.options

						if (!options) return

						const optionsKeys = Object.keys(options)

						optionsKeys.forEach((key) => {
							const keyString = String(key)

							if (keyString.includes('signature_')) {
								groupsFilter.push(group)
							}
						})
					})
				})

				groupsFilter = groupsFilter.filter(
					(value, index, self) => index === self.findIndex((t) => t.id === value.id),
				)

				return groupsFilter
			},

			getProponentes() {
				let proponentes = []

				this.getConjugeProponentes.forEach((item) => {
					const fields = item.fields
					let conjugeField = null

					fields.forEach((field) => {
						if (field && field.slug === 'casado-com-1-preponente') conjugeField = field
					})

					if (
						!conjugeField ||
						!conjugeField.value ||
						conjugeField.value.value === 'Não' ||
						conjugeField.value.value === ''
					) {
						// Add proponente
						proponentes.push(item)
					}
				})

				return proponentes
			},

			getConjuge() {
				let conjuge = null

				this.getConjugeProponentes.forEach((item) => {
					const fields = item.fields
					let conjugeField = null

					fields.forEach((field) => {
						if (field && field.slug === 'casado-com-1-preponente') conjugeField = field
					})

					if (!conjugeField) {
						return
					}

					if (conjugeField.value && conjugeField.value.value === 'Sim') conjuge = fields
				})

				return conjuge
			}
		},

		async mounted() {
			this.$root.$on('modal-open-select-subscrib', async () => {
				this.openIframe('closed-modal')

				// Start master loading
				this.loader.body = true

				this.getAllParams()

				await this.getDealDetails()
				await this.getCurrentProductSigners(this.paramsData.productId, this.paramsData.dealId)

				this.mountUsersList()

				// Finish master loading
				this.loader.body = false

				if (this.productMode) {
					this.loader.allSigners = true
					await this.getAllSigners()
					this.loader.allSigners = false
				}
			})

			this.$root.$on('modal-close-select-subscrib', () => {
				this.flowData = { ...defaultFlowData() }
				this.paramsData = { ...defaultParamsData() }
				this.loader = { ...defaultLoader() }
			})

			this.$root.$on('search-user--verify-username', value => {
				this.searchHandler(value)
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-select-subscrib')
			this.$root.$off('search-user--verify-username')
		},

		methods: {
			add() {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-adicionar-assinante',
					action: 'click',
					label: 'Adicionar Assinante'
				})

				this.properList.push({
					__group: 'Usuário Não Facilita',
					name: null,
					email: null,
					whatsapp_number: null,
					notify_whatsapp: true,
					cpf: null,
					birthday: null,
					signatureType: null,
					new: true,
				})
			},
			/**
			 * Fecha o modal
			 */
			close() {
				let event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
			},
			/**
			 * Emite um evento para atualizar o Iframe no painel Legado e fecha o modal
			 */
			realoadAndClose() {
				let event = new CustomEvent('iframe--contracts-reload-page')
				window.parent.document.dispatchEvent(event)
				this.close()
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			getAllParams() {
				this.paramsData.files = this.$route.params.files
					? JSON.parse(this.$route.params.files)
					: null
				this.paramsData.flowName = this.$route.params.flowName
					? String(this.$route.params.flowName)
					: null
				this.paramsData.flowType = this.$route.params.flowType
					? Number(this.$route.params.flowType)
					: null
				this.paramsData.dealId = this.$route.params.dealId
					? Number(this.$route.params.dealId)
					: null
				this.paramsData.productId = this.$route.params.productId
					? Number(this.$route.params.productId)
					: null
			},

			async getAllSigners() {
				try {
					const { data } = await digitalSignature.getAllV2('/signers')

					// Not show the current product on configuration screen
					this.flowData.allSigners = data.data.filter(
						(item) => item.products_id != this.paramsData.productId,
					)
				} catch {
					this.flowData.allSigners = null
				}
			},

			async getCurrentProductSigners(productId, dealId) {
				if (!productId || (!this.productMode && !dealId)) return

				const params = { type: 0 }
				if (!this.productMode) params.deal_id = dealId

				try {
					const signers = await digitalSignature.getAllV2(`/signers/${productId}`, params)
					const infos = await product.getProducts(productId)

					signers.data.data.forEach((item) => {
						item.signatureType = Number(item.signature_type) + 1
						delete item.signature_type
					})

					this.flowData.currentProductSigners = {
						signers: signers.data.data,
						product: { ...infos.data },
					}

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
					this.flowData.currentProductSigners = null
				}
			},

			async getDealDetails() {
				if (this.productMode) return

				try {
					const { data } = await deal.getV2('', this.paramsData.dealId)
					this.paramsData.dealData = data.data

					if (!this.paramsData.productId)
						this.paramsData.productId = this.paramsData.dealData.product_id
				} catch {
					this.paramsData.dealData = null
					this.paramsData.productId = null
				}
			},

			properType(type) {
				switch (type) {
					case 'customer':
						return 'Cliente do Negócio'
					case 'user':
						return 'Usuário Facilita'
					case 'manager':
						return 'Gerente de Vendas'
					case 'broker':
						return 'Corretor de Imóveis'
					case 'nonuser':
						return 'Usuário Não Facilita'
					default:
						break
				}
			},

			proponenteCredentials(fields) {
				if (!fields || fields.length == 0) return null

				let name = null
				let email = null
				let birthday = null
				let cpf = null

				fields.forEach((item) => {
					switch (item.slug) {
						case 'nome':
							name = item.value ? item.value.value : null
							break
						case 'email':
							email = item.value ? item.value.value : null
							break
						case 'data-nascimento-fundacao':
							birthday = item.value ? item.value.value : null
							break
						case 'cpf':
							cpf = item.value ? item.value.value : null
							break
						default:
							break
					}
				})

				// You can only sign if the name and email are filled in
				const nameAndEmailFilled = name && name != '' && email && email != ''

				return {
					name: name,
					email: email,
					birthday,
					cpf,
					canSign: nameAndEmailFilled,
				}
			},

			populateNormalList(digitalSignatureSigners) {
				digitalSignatureSigners.forEach((item) => {
					const data = item

					// New data
					let newName = null
					let newEmail = null
					let newUsersId = null
					let newCPF = null
					let newNasc = null

					switch (item.type) {
						case 'user':
							var payloadUser = {
								position: data.position,
								data: { ...data, selected: true, checked: true },
							}

							this.flowData.list.push(payloadUser)
							this.selectedIds.push(data.users_id)
							this.temporary.ids.push(data.users_id)
							break

						case 'manager':
							if (!this.productMode) {
								// Delete for add new data later
								delete data['name']
								delete data['email']
								delete data['users_id']

								const hasManager = this.paramsData.dealData.owners.manager
								// Verifica se o negócio possui um gerente e adiciona este como assinante
								if (hasManager) {
									newName =
										this.paramsData.dealData.owners.manager.user.first_name
									newEmail = this.paramsData.dealData.owners.manager.user.email
									newUsersId = this.paramsData.dealData.owners.manager.user.id
									newCPF = this.paramsData.dealData.owners.manager.user.cpf
									newNasc = this.paramsData.dealData.owners.manager.user.birthday

									const payloadManager = {
										position: data.position,
										data: {
											...data,
											name: newName,
											email: newEmail,
											users_id: newUsersId,
											group: this.properType(data.type),
											cpf: newCPF,
											birthday: newNasc,
											checked: true,
										},
									}

									this.flowData.list.push(payloadManager)
								}

							} else {
								const payloadManager = {
									position: data.position,
									data: {
										...data,
										group: this.properType(data.type),
										checked: true,
									},
								}

								this.flowData.list.push(payloadManager)
							}
							break

						case 'broker':
							if (!this.productMode) {
								// Delete for add new data later
								delete data['name']
								delete data['email']
								delete data['users_id']

								const hasBroker = this.paramsData.dealData.owners.broker
								// Verifica se o negócio possui um corretor e adiciona este como assinante
								if (hasBroker) {
									newName = this.paramsData.dealData.owners.broker.user.first_name
									newEmail = this.paramsData.dealData.owners.broker.user.email
									newUsersId = this.paramsData.dealData.owners.broker.user.id
									newCPF = this.paramsData.dealData.owners.broker.user.cpf
									newNasc = this.paramsData.dealData.owners.broker.user.birthday

									const payloadBroker = {
										position: data.position,
										data: {
											...data,
											name: newName,
											email: newEmail,
											users_id: newUsersId,
											group: this.properType(data.type),
											cpf: newCPF,
											birthday: newNasc,
											checked: true,
										},
									}

									this.flowData.list.push(payloadBroker)
								}
							} else {
								const payloadBroker = {
									position: data.position,
									data: {
										...data,
										group: this.properType(data.type),
										checked: true,
									},
								}

								this.flowData.list.push(payloadBroker)
							}
							break

						case 'nonuser':
							var payloadNonuser = {
								position: data.position,
								data: {
									...data,
									group: this.properType(data.type),
									checked: true,
								},
							}

							this.flowData.list.push(payloadNonuser)
							break
					}
				})

				/**
				 * Na etapa 2 verifica se o gerente e o corretor foram configurados. Caso
				 * não tenham sido, adiciona as opções default para seleção
				 */
				if (this.productMode) {
					const managerBrokerTypes = [...digitalSignatureSigners]
						.filter(signer => ['manager', 'broker'].includes(signer.type))
						.map(signer => signer.type)
					if (!managerBrokerTypes.includes('manager')) {
						this.flowData.list.splice(0, 0, {
							position: 1,
							data: {
								name: 'Gerente',
								group: 'Gerente de Vendas',
								checked: false,
							}
						})
					}
					if (!managerBrokerTypes.includes('broker')) {
						this.flowData.list.splice(1, 0, {
							position: 2,
							data: {
								name: 'Corretor',
								group: 'Corretor de Imóveis',
								checked: false,
							}
						})
					}
					// Refaz o posicionamento de acordo com os indexes
					for (const [index, signer] of this.flowData.list.entries()) {
						signer.position = index
					}
				}
			},

			populateCustomersList(digitalSignatureSigners) {
				digitalSignatureSigners.forEach((item) => {
					const data = item

					switch (item.type) {
						case 'customer':
							if (!this.productMode) {
								// Delete for add new data later
								delete data['name']
								delete data['email']
								delete data['users_id']

								const newName = this.paramsData.dealData.customer.name
								const newEmail = this.paramsData.dealData.customer.email
								const newUsersId = this.paramsData.dealData.customer.id_customer
								const newCPF = this.paramsData.dealData.customer.cpf
								const newWhatsapp = this.paramsData.dealData.customer.mobile

								let newNasc = null
								this.paramsData.dealData.groups.forEach(group => {
									const fields = group.fields

									fields.forEach(field => {
										if (!field.options) return null

										if (field.slug === 'data-nascimento' &&
											field.options &&
											field.options.signature_customer === 'birthday' &&
											field.value) {
											newNasc = field.value.value
										}
									})
								})

								// -------------------------------- Cliente -------------------------------- //
								const payload = {
									...data,
									name: newName,
									email: newEmail,
									users_id: newUsersId,
									group: this.properType(data.type),
									cpf: newCPF,
									birthday: newNasc,
									whatsapp_number: newWhatsapp,
									checked: true,
								}

								this.flowData.list.splice(data.position, 0, payload)

								// -------------------------------- Cônjuge -------------------------------- //
								let proponenteCount = 1

								if (
									this.proponenteCredentials(this.getConjuge) &&
									this.proponenteCredentials(this.getConjuge).canSign
								) {
									const payloadConjuge = {
										...this.proponenteCredentials(this.getConjuge),
										group: 'Cônjuge do Cliente',
										signatureType: data.signatureType,
										type: data.type,
										checked: true,
									}

									this.flowData.list.splice(
										data.position + proponenteCount,
										0,
										payloadConjuge,
									)

									proponenteCount += 1
								}
								// --------------------------- Outros Proponentes --------------------------- //
								if (this.getProponentes && this.getProponentes.length > 0) {
									this.getProponentes.forEach((item) => {
										if (
											this.proponenteCredentials(item.fields) &&
											this.proponenteCredentials(item.fields).canSign
										) {
											const payloadProponente = {
												...this.proponenteCredentials(item.fields),
												group: 'Proponente do Negócio',
												signatureType: data.signatureType,
												type: data.type,
												checked: true,
											}

											this.flowData.list.splice(
												data.position + proponenteCount,
												0,
												payloadProponente,
											)

											proponenteCount += 1
										}
									})
								}
							} else {
								const payload = {
									...data,
									group: this.properType(data.type),
									checked: true,
								}

								this.flowData.list.splice(data.position, 0, payload)
							}

							break
						default:
							break
					}
				})
			},

			sortList() {
				let array = this.flowData.list.sort((a, b) => {
					if (a.position < b.position) return -1
					if (a.position > b.position) return 1

					return 0
				})

				let newArray = []
				array.forEach((item) => {
					newArray.push({ ...item.data })
				})

				this.flowData.list = newArray
			},

			mountUsersList() {
				const signers = this.flowData.currentProductSigners
					? this.flowData.currentProductSigners.signers
					: []

				this.populateNormalList(signers)
				this.sortList()
				this.populateCustomersList(signers)
			},

			digitalSignatureSignersPayload(list, signatureBalance = 1) {
				let data = {
					products_id: this.productId, // Product ID from iFrame
					digital_signature_id: null,
					digitalSignatureSigners: {
						customer: [],
						user: [],
						nonuser: [],
						manager: [],
						broker: [],
					},
				}

				list.forEach((item) => {
					const signature = item.signatureType || item.signature_type

					delete item['signature_type']
					delete item['position']
					delete item['id']

					if (item.type == 'customer') {
						data.digitalSignatureSigners.customer.push({
							...item,
							signatureType: signature - signatureBalance,
							position: list.indexOf(item),
						})
					} else if (item.type == 'user') {
						data.digitalSignatureSigners.user.push({
							...item,
							signatureType: signature - signatureBalance,
							position: list.indexOf(item),
						})
					} else if (item.type == 'manager') {
						data.digitalSignatureSigners.manager.push({
							...item,
							signatureType: signature - signatureBalance,
							position: list.indexOf(item),
						})
					} else if (item.type == 'broker') {
						data.digitalSignatureSigners.broker.push({
							...item,
							signatureType: signature - signatureBalance,
							position: list.indexOf(item),
						})
					} else if (item.type == 'nonuser') {
						data.digitalSignatureSigners.nonuser.push({
							name: item.name,
							email: item.email,
							signatureType: signature - signatureBalance,
							position: list.indexOf(item),
						})
					}
				})

				return data
			},

			digitalSignatureSignersProductPayload(list, signatureBalance = 1) {
				let data = {
					products_id: this.productId, // Product ID from iFrame
					digital_signature_id: null,
					digitalSignatureSigners: {
						customer: [],
						user: [],
						nonuser: [],
						manager: [],
						broker: [],
					},
				}

				let allowedList = []

				const mountAllowedList = () => {
					list.forEach((item) => {
						if (item.checked) allowedList.push(item)
					})
				}

				const mountPayload = () => {
					allowedList.forEach((item) => {
						const signature = item.signatureType || item.signature_type

						switch(item.group) {
							case 'Cliente do Negócio':
								data.digitalSignatureSigners.customer.push({
									signatureType: signature - signatureBalance,
									position: list.indexOf(item),
									name: 'Clientes',
								})
								break

							case 'Gerente de Vendas':
								data.digitalSignatureSigners.manager.push({
									signatureType: signature - signatureBalance,
									position: list.indexOf(item),
									name: 'Gerente',
								})
								break

							case 'Corretor de Imóveis':
								data.digitalSignatureSigners.broker.push({
									signatureType: signature - signatureBalance,
									position: list.indexOf(item),
									name: 'Corretor',
								})
								break

							default:
								var signer = {
									...item,
									cpf: item.cpf ? item.cpf.replace(/[^0-9]+/g,'') : '',
									whatsapp_number: item.whatsapp_number
										? item.whatsapp_number.replace(/[^0-9]+/g,'')
										: '',
									signatureType: signature - signatureBalance,
									position: list.indexOf(item),
								}

								// Verifica se o usuário é do tipo Facilita
								if (item.__group == 'Usuário Não Facilita' ||
									item.group == 'Usuário Não Facilita') {
									data.digitalSignatureSigners.nonuser.push(signer)

								} else {
									data.digitalSignatureSigners.user.push(signer)
								}
						}
					})
				}

				mountAllowedList()
				mountPayload()

				return data
			},

			async saveClonedSigners() {
				this.loader.message = 'Clonando dados do empreendimento...'

				try {
					this.loader.modalLoading = true

					const { data } = await digitalSignature.getAllV2(
						`/signers/${this.flowData.selectedAllSigners}?type=0`,
					)

					await digitalSignature.createV2(
						'/signers',
						this.digitalSignatureSignersPayload(data.data, 0),
					)
					this.loader.modalSuccess = true
					this.loader.message = 'Clonagem realizada com sucesso!'

					// Close iframe modal
					setTimeout(() => {
						this.close()
					}, 3000)

				} catch (error) {
					console.log(error)
					if (error.data && error.data.msg) {
						this.loader.message = 'Falha ao clonar dados do empreendimento!'
						this.$toastr.e(error.data.msg)
					}
					this.loader.modalFailed = true
					setTimeout(() => {
						this.loader.modalLoading = false
					}, 3000)
				}
			},

			async save() {
				// If an product was selected to be cloned, then interrupt the original flow
				if (this.validSelectedAllSigners) {
					await this.saveClonedSigners()
					return
				}

				this.loader.message = 'Enviando dados...'
				try {
					this.loader.modalLoading = true

					await digitalSignature.createV2(
						'/signers',
						this.digitalSignatureSignersProductPayload(this.properList),
					)
					this.loader.modalSuccess = true
					this.loader.message = 'Finalizado!'

					// Close iframe modal
					setTimeout(() => {
						this.close()
					}, 3000)
					// this.$root.$emit('modal-close-select-subscrib')

				} catch (error) {
					console.log(error)
					if (error.data && error.data.msg) {
						this.loader.message = 'Falha ao enviar os dados!'
						this.$toastr.e(error.data.msg)
					}
					this.loader.modalFailed = true
					setTimeout(() => {
						this.loader.modalLoading = false
					}, 3000)
				}
			},

			async saveTemplate() {
				const payload = {
					flow: this.paramsData.flowName,
					file_id: this.paramsData.files,
					deal_id: this.paramsData.dealId,
					signers: [],
				}

				// Input signers
				this.properList.filter(signer => signer.checked)
					.forEach((signer) => {
						let signerData = {
							...signer,
							fields: {
								type: this.paramsData.flowType,
								height: 50,
								width: 200,
								page: 1,
							},
						}

						// Remove a máscara do número de WhatsApp
						if (signerData.whatsapp_number) {
							signerData.whatsapp_number = signerData.whatsapp_number.replace(/[^0-9]+/g,'')
						}

						// Remove a máscara do CPF
						if (signerData.cpf) signerData.cpf = signerData.cpf.replace(/[^0-9]+/g,'')

						signerData.signatureType = signerData.signatureType - 1

						// If is invisible flow type
						// if (this.paramsData.flowType == 16) {
						// 	signerData['fields']['x'] = 50
						// 	signerData['fields']['y'] = 30
						// }

						// Only send selected signers
						if (signer.checked) payload.signers.push(signerData)
					})

				// workflow = 16
				// template = 8

				// Dont continue if has error
				if (this.checkSignersCredentials(payload.signers)) return

				// Alright, everything is good with signers, continue the flow
				this.loader.message = 'Criando fluxo...'
				try {
					this.loader.modalLoading = true

					await digitalSignature.createV2('/template', payload)
					this.loader.message = 'Fluxo criado com sucesso!'
					this.loader.modalSuccess = true
					// Reload page to update flowr list
					setTimeout(() => {
						this.realoadAndClose()
					}, 3000)

				} catch (error) {
					console.log(error)
					if (error.data && error.data.msg) {
						this.loader.message = 'Falha ao criar o fluxo!'
						this.$toastr.e(error.data.msg)
					}
					this.loader.modalFailed = true
					setTimeout(() => {
						this.loader.modalLoading = false
					}, 3000)
				}
			},

			async handleSaveButton() {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-salvar-fluxo',
					action: 'click',
					label: 'Salvar Fluxo'
				})

				if (this.productMode) {
					await this.save()
					return
				}

				await this.saveTemplate()
			},

			deleteSignerFromList(element) {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-excluir-assinante',
					action: 'click',
					label: 'Excluir Assinante'
				})

				const newArray = this.properList.filter((item) => item.name != element.name)

				if (this.productMode && !this.signersOnProduct) this.flowData.productList = newArray
				else this.flowData.list = newArray
			},

			// Check if name and email are filled in
			checkSignersCredentials(signers) {
				let hasError = false

				const existsText = (item) => {
					return !item || item == '' ? 'NÃO EXISTE' : item
				}

				signers.every((item) => {
					if (!item.name || item.name == '' || !item.email || item.email == '') {
						// Show error
						this.$toastr.e(
							'Há credenciais inválidas em um signatário. Mais informações: Nome: ' +
								existsText(item.name) +
								'; Email: ' +
								existsText(item.email),
						)

						hasError = true
						return false
					}

					return true
				})

				return hasError
			},
			/**
			 * Recebe os dados de um assinante e define se esse não pode ser removido
			 */
			cantDelete(signer) {
				return signer.type == 'customer' ||
					[
						'Cliente do Negócio',
						'Proponente do Negócio',
						'Cônjuge do Cliente',
						'Gerente de Vendas',
						'Corretor de Imóveis'
					].includes(signer.group)
			},
			/**
			 * Retorna a classe CSS do checkbox de acordo com as restrições de tipo e grupo
			 * de usuários do assinante
			 */
			checkboxDesign(signer) {
				return signer.type == 'customer' ||
					[
						'Cliente do Negócio',
						'Proponente do Negócio',
						'Cônjuge do Cliente',
					].includes(signer.group)
						? 'xs disabled cant-delete'
						: 'xs success'
			},
			/**
			 * Event handler que trata o evento de quando um tipo de assinatura é escolhido
			 * para um assinante
			 */
			signatureTypeHandler (type) {
				if (!type) return

				let category = ''
				let label = ''
				switch (type) {
					case 1:
						category = 'vue-assinatura-eletronica'
						label = 'Assinatura Eletrônica'
						break

					case 2:
						category = 'vue-assinatura-digital'
						label = 'Assinatura Digital'
						break

					case 3:
						category = 'vue-assinatura-presencial'
						label = 'Assinatura Presencial'
						break
				}
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })
			},
			/**
			 * Event handler que trata os eventos emitidos pelo select de tipo de assinatura
			 */
			selectHandler(event = 'cancel') {
				let category = ''
				let label = ''
				switch(event) {
					case 'cancel':
						category = 'vue-cancelar'
						label = 'Cancelar'
						break

					case 'remove':
						category = 'vue-remover-selecao'
						label = 'Remover Seleção'
						break
				}
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })
			},
			/**
			 * Event handler que trata o evento de quando o select para clonar configurações é
			 * utilizado
			 */
			cloneHandler(event = 'open') {
				let category = ''
				let label = ''
				switch(event) {
					case 'cancel':
						category = 'vue-cancelar-clonagens'
						label = 'Cancelar Clonagens'
						break

					case 'open':
						category = 'vue-clonar-configuracoes'
						label = 'Clonar Configurações'
						break

					case 'search':
						category = 'vue-buscar-configuracoes'
						label = 'Buscar Configurações'
						break
				}
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })
			},
			/**
			 * Event handler que trata o evento de quando as opções do select devem ser escondidas
			 */
			closeCardHandler() {
				this.showUsers = false
				this.users = []
				this.temporary.signers = []
				this.temporary.ids = [...this.selectedIds]
			},
			/**
			 * Event handler que trata o evento de quando uma busca é feita no input de usuários
			 */
			searchHandler(value) {
				this.users = []
				this.showUsers = false
				this.emptyUsers = false

				if (!value)	return

				this.interval = setInterval(() => {
					clearInterval(this.interval)
					if (this.form.name.length > 2) {
						this.loader.name = true
						user.getAllV2('list', { search: this.form.name })
							.then(response => {
								this.users = response.data.data.map(user => {
									user.selected = this.selectedIds.includes(user.id)

									return user
								})

								if (this.users.length) this.showUsers = true

								if (this.users.length === 0) this.emptyUsers = true
							})
							.catch(error => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
								console.log(error)
							})
							.finally(() => {
								this.loader.name = false
							})
					}
                }, 1000)
			},
			/**
			 * Event handler que trata o evento de quando um usuário é selecionado
			 */
			selectUserHandler(user) {
				const index = this.temporary.ids.findIndex(id => id === user.id)
				if (index >= 0) {
					this.temporary.ids.splice(index, 1)
					const sIndex = this.temporary.signers.findIndex(signer => signer.users_id === user.id)
					this.temporary.signers.splice(sIndex, 1)

				} else {
					this.temporary.ids.push(user.id)
					this.temporary.signers.push({
						users_id: user.id,
						name: user.first_name,
						email: user.email,
						whatsapp_number: user.mobile,
						notify_whatsapp: true,
						cpf: user.cpf,
						birthday: user.birthday,
						photo: user.photo,
						group: user.group,
						group_name: this.getGroupLabel(user.group),
						checked: true,
						selected: true,
					})
				}
			},
			/**
			 * Salva as seleções de usuários buscados no select adicionando ou removendo estes
			 * como assinantes
			 */
			setSelectedSigners() {
				let signers = [...this.properList, ...this.temporary.signers]
				// Remove os assinantes do tipo selected cujos IDs não estão mais selecionados
				for (const [index, signer] of signers.entries()) {
					if (signer.selected && !this.temporary.ids.includes(signer.users_id)) signers.splice(index, 1)
				}

				// Atualiza o array de assinantes
				this.properList = [...signers]
				this.selectedIds = [...this.temporary.ids]
				this.closeCardHandler()
			},
			/**
			 * Retorna o label do grupo de usuários para um usuário selecionado
			 */
			getGroupLabel(value) {
				let label = 'Não definido'

				if (value) {
					switch(value) {
						case 'admin':
							label = 'Administrador'
							break

						case 'manager':
							label = this.configurations.manager.label || 'Gerente'
							break

						case 'broker':
							label = this.configurations.broker.label || 'Corretor'
							break

						case 'supervisor':
							label = 'Supervisor'
							break

						case 'collaborator':
							label = 'Colaborador'
							break

						default:
							label = value
							break
					}
				}

				return label
			},
			/**
			 * Recebe o CPF de um usuário e o formata de acordo
			 */
			formatCPF(cpf) {
				return cpf
					? this.$options.filters.documentBr(cpf)
					: 'CPF não informado'
			},
			/**
			 * Recebe a data de nascimento de um usuário e a formata de acordo
			 */
			formatBirthDate(birthDate) {
				let formatted = birthDate
				if (birthDate && !moment(birthDate, 'DD/MM/YYYY', true).isValid()) {
					formatted = moment(birthDate).format("DD/MM/YYYY")

				} else if (!birthDate) {
					formatted = 'Data de nascimento não informada'
				}

				return formatted
			}
		},
	}
</script>

<style scoped>
	.buttons {
		margin-top: 35px;
	}
	.ghost {
		opacity: 0.5;
		background: #c8ebfb;
	}
</style>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
